

import React from 'react'
import WebMaintenanceDetail from '../components/web-maintenancedetail'
import WebmaintenanceData from '../components/web-maintenancedata'
import Leadmaintenanceweb from '../components/Lead-maintenance'
import usePageMeta from '../hooks/usePageMeta';
export default function CmsWeb() {
    usePageMeta('Website Maintenance & Support Services | Spinnennetz', 'Keep your website secure, updated, and performing at its best with our reliable website maintenance packages. We ensure your site remains fast and bug-free.', '/web-maintenance', {"@context":"https://schema.org","@type":"Service","name":"Website Maintenance & Support","provider":{"@type":"Organization","name":"Spinnennetz"}});
    return (
        <>
        <WebMaintenanceDetail />
        <WebmaintenanceData/>
        <Leadmaintenanceweb/>
        </>
    )
}
